import { render, staticRenderFns } from "./CardExpertDocs.vue?vue&type=template&id=1ad847fa&scoped=true&"
import script from "./CardExpertDocs.vue?vue&type=script&lang=js&"
export * from "./CardExpertDocs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad847fa",
  null
  
)

export default component.exports